import { useState } from "react";
import { DeviceFrame } from "./DeviceFrames.tsx";
import { ExportControls } from "./ExportControls.tsx";
import styles from "./ScreenshotGenerator.module.css";
import { TEMPLATES } from "./ScreenshotTemplates.tsx";
import type { ScreenshotTemplate } from "./ScreenshotTemplates.tsx";
import { DEVICES } from "./devices.ts";
import type { DeviceSpec } from "./devices.ts";

export function ScreenshotGenerator() {
  const [selectedDevice, setSelectedDevice] = useState<DeviceSpec>(DEVICES[0]);
  const [selectedTemplate, setSelectedTemplate] = useState<ScreenshotTemplate>(TEMPLATES[0]);
  const [headline, setHeadline] = useState(TEMPLATES[0].headline);
  const [subtitle, setSubtitle] = useState(TEMPLATES[0].subtitle);
  const [screenshotImage, setScreenshotImage] = useState<HTMLImageElement | null>(null);

  return (
    <div className={styles.generator}>
      <div className={styles.header}>
        <h1 className={styles.title}>App Store Screenshot Generator</h1>
        <p className={styles.subtitle}>
          Generate pixel-perfect screenshots for App Store submission
        </p>
      </div>

      <div className={styles.workspace}>
        <aside className={styles.sidebar}>
          <ExportControls
            selectedDevice={selectedDevice}
            onDeviceChange={setSelectedDevice}
            selectedTemplate={selectedTemplate}
            onTemplateChange={setSelectedTemplate}
            headline={headline}
            onHeadlineChange={setHeadline}
            subtitle={subtitle}
            onSubtitleChange={setSubtitle}
            screenshotImage={screenshotImage}
            onImageChange={setScreenshotImage}
          />
        </aside>

        <main className={styles.preview}>
          <DeviceFrame
            device={selectedDevice}
            template={selectedTemplate}
            headline={headline}
            subtitle={subtitle}
            screenshotImage={screenshotImage}
            maxPreviewHeight={700}
          />
        </main>
      </div>
    </div>
  );
}
